var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBdChatIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 29.2,
    height: 29.203,
    viewBox: "0 0 29.2 29.203",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "chat_5_",
    "data-name": "chat (5)",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_71",
    "data-name": "Path 71",
    d: "M5.367,23.86h2.92v2.414a3.478,3.478,0,0,0,1.671,3.1,2.581,2.581,0,0,0,1.249.331,2.612,2.612,0,0,0,1.39-.413l8.625-5.43h3.612A4.872,4.872,0,0,0,29.7,18.993V5.367A4.872,4.872,0,0,0,24.833.5H5.367A4.872,4.872,0,0,0,.5,5.367V18.993A4.872,4.872,0,0,0,5.367,23.86ZM2.447,5.367a2.923,2.923,0,0,1,2.92-2.92H24.833a2.923,2.923,0,0,1,2.92,2.92V18.993a2.923,2.923,0,0,1-2.92,2.92H20.94a.981.981,0,0,0-.519.149l-8.862,5.578a.6.6,0,0,1-.66.027,1.553,1.553,0,0,1-.665-1.394V22.886a.973.973,0,0,0-.973-.973H5.367a2.923,2.923,0,0,1-2.92-2.92Z",
    transform: "translate(-0.5 -0.5)",
    fill: "#40eefe"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBdChatIcon);
export default __webpack_public_path__ + "static/media/bd-chat-icon.950ba9c40737aaaa69d1fe76bd367584.svg";
export { ForwardRef as ReactComponent };